module.exports = __webpack_public_path__ + "img/7.53048a8f.webp";